import { type BackendGraph } from "./graph";

export default function (graph: BackendGraph) {

  return {

    async orderByDelivery(deliveryId: string) {

      const response = await graph.queryTable({
        edge: 'deliveries',
        limit: 1,
        filter: `deliveryId == ${deliveryId}`,
        node: {
          fields: ['deliveryId'],
          navigate: [{
            edge: 'order',
            node: {
              fields: ['orderId']
            }
          }]
        }
      });

      const orderIds = response.rows.map(r => r[1]);

      if (orderIds.length === 0) {
        return;
      }

      return orderIds[0] as string;
    },

    async orderByOrderLine(orderLineId: string) {

      const response = await graph.queryTable({
        edge: 'orderLines',
        limit: 1,
        filter: `orderLineId == ${orderLineId}`,
        node: {
          fields: ['orderLineId'],
          navigate: [{
            edge: 'order',
            node: {
              fields: ['orderId']
            }
          }]
        }
      });

      const orderIds = response.rows.map(r => r[1]);

      if (orderIds.length === 0) {
        return;
      }

      return orderIds[0] as string;
    },

    async orderByTicket(ticketId: string) {

      const response = await graph.queryTable({
        edge: 'tickets',
        limit: 1,
        filter: `ticketId == ${ticketId}`,
        node: {
          fields: ['ticketId'],
          navigate: [{
            edge: 'relatedOrders',
            node: {
              fields: ['orderId']
            }
          }]
        }
      });

      const orderIds = response.rows.map(r => r[1]);

      if (orderIds.length === 0) {
        return;
      }
      // Tickets can have multiple orders, but we only return the first one for now. This is a workaround until we
      // have a proper ticket view.

      return orderIds[0] as string;
    },

    async orderByInvoice(invoiceId: string) {

      const response = await graph.queryTable({
        edge: 'invoices',
        limit: 1,
        filter: `invoiceId == ${invoiceId}`,
        node: {
          fields: ['invoiceId'],
          navigate: [{
            edge: 'order',
            node: {
              fields: ['orderId']
            }
          }]
        }
      });

      const orderIds = response.rows.map(r => r[1]);

      if (orderIds.length === 0) {
        return;
      }

      return orderIds[0] as string;
    }

  };

}